export const priceWithSpaceAndCurrency = (x: number) => {
    const price = Math.round(x) || 0;
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ", ");
}
